import { SrOnly, buildResponsiveSize } from '@tvg/fuse-utils';
import PropTypes from 'prop-types';
import React from 'react';
import { ratingCssConfig } from './config';
import { RatingNumber } from './rating-number';
import {
	Container,
	Stars,
	StyledDiv,
	StyledLink,
	StyledReview
} from './styled-rating'

const propTypes = {
	dataTestId: PropTypes.string,
	rating: PropTypes.number,
	showRating: PropTypes.bool,
	reviewLinkText: PropTypes.string,
	reviewLink: PropTypes.string,
	size: PropTypes.oneOfType([
		PropTypes.oneOf(['small', 'medium', 'large']),
		PropTypes.shape({
			xxs: PropTypes.string,
			xs: PropTypes.string,
			s: PropTypes.string,
			m: PropTypes.string,
			l: PropTypes.string,
			xl: PropTypes.string,
			xxl: PropTypes.string,
		}),
	]),
};
const defaultProps = {
	dataTestId: null,
	rating: 0,
	showRating: false,
	reviewLinkText: null,
	reviewLink: null,
	size: 'large',
};

function Rating({ dataTestId, size, rating, showRating, reviewLinkText, reviewLink, ...others }) {
	const getResponsiveFontSize = () => {
		const [isResponsive] = buildResponsiveSize(size);

		if (isResponsive) {
			const processedSize = {};
			Object.keys(size).forEach((viewport) => {
				processedSize[viewport] = ratingCssConfig[size[viewport]].fontSize;
			});

			return processedSize;
		}

		return ratingCssConfig[size].fontSize;
	};

	function renderReview(text, link) {
		if (link) {
			return (
				<StyledLink href={link} size={size} data-testid={dataTestId && `${dataTestId}__review`}>
					{text}
				</StyledLink>
			);
		}

		return (
			<StyledReview
				size={getResponsiveFontSize()}
				type="paragraph"
				data-testid={dataTestId && `${dataTestId}__review`}
			>
				{text}
			</StyledReview>
		);
	}
	const screenReaderText = `${rating} out of 5 stars`;

	return (
		<Container data-testid={dataTestId} size={size} {...others}>
			<Stars
				rating={rating}
				size={size}
				data-testid={dataTestId && `${dataTestId}__stars-number`}
				data-rating={rating}
			/>
			<StyledDiv size={size}>
				{showRating ? (
					<RatingNumber rating={rating} size={size} />
				) : (
					<SrOnly>{screenReaderText}</SrOnly>
				)}
				{reviewLinkText && renderReview(reviewLinkText, reviewLink)}
			</StyledDiv>
		</Container>
	);
}

Rating.propTypes = propTypes;
Rating.defaultProps = defaultProps;

export { Rating };

export default Rating;
